// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2Oju_","item":"PaymentsMobile_item__2c1Dp","label":"PaymentsMobile_label__F_qZE","amount":"PaymentsMobile_amount__3WLlQ"};